import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enMaintenance from './locales/en/maintenance.json';

// Pinned to English until a second locale is added. Re-introduce a language
// detector and add locales under `resources` when that happens.
i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { maintenance: enMaintenance },
    },
    lng: 'en',
    fallbackLng: 'en',
    supportedLngs: ['en'],
    ns: ['maintenance'],
    defaultNS: 'maintenance',
    interpolation: { escapeValue: false },
  });

export default i18n;
